import * as Sentry from "@sentry/react";
import { CONSTANTS } from "./config/constants";

const enabled = CONSTANTS.IS_PRODUCTION || CONSTANTS.IS_STAGING;
const env = (CONSTANTS.APP_ENV as string).toLowerCase();

// Only sample performance traces & session replays in production. QA (staging)
// and local capture errors (and error-triggered replays) only — no volumetric
// sampling — so non-prod traffic doesn't burn the Sentry quota.
const tracesSampleRate = CONSTANTS.IS_PRODUCTION ? 0.2 : 0;
const replaysSessionSampleRate = CONSTANTS.IS_PRODUCTION ? 0.1 : 0;

let IS_INITIALIZED = false;
if (!IS_INITIALIZED) {
  Sentry.init({
    dsn: "https://cd1a3b3448cd469f1f4d6e98485df20f@o4508974719893504.ingest.de.sentry.io/4510905278070864",
    sendDefaultPii: true,
    environment: env,
    enabled,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],
    replaysSessionSampleRate, // prod only (10%); 0 in QA/local
    replaysOnErrorSampleRate: 1.0, // always capture a replay when an error occurs

    enableLogs: true,
    tracesSampleRate, // prod only (20%); 0 in QA/local
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/api.replyn\.(io | dev)\/api/],
  });

  IS_INITIALIZED = true;
}
